import { Lookup } from './lookup.model';
import { OptionSet } from './optionSet.model';
export class Contact {

    public TipoDocumentos: OptionSet;
    public Nacionalidad: OptionSet;
    public Rut: string;
    public Nombre: string;
    public Nombre2: string;
    public ApellidoP: string;
    public ApellidoM: string;
    public Genero: OptionSet;
    public FechaNacimiento: string;
    public EstadoCivil: OptionSet;
    public CorreoElectronico: string;
    public Telefono: string;
    public Celular: string;
    public Region: Lookup;
    public Comuna: Lookup;
    public Ciudad: Lookup;
    public Calle: string;
    public CalleNro: string;
    public CalleDpto: string;
    public Banco: string;
    public TipoDeCuenta: string;
    public NroDeCuenta: string;
    public Pais: Lookup;
    public PresentaDiscapacidad: OptionSet;
    public DeseaRecibirAsesoria: boolean;
    public Etnia: OptionSet;
    public EnsenhazaMediaEextranjero: boolean;
    public PrimeroMedioExterior: boolean;
    public SegundoMedioExterior: boolean;
    public TerceroMedioExterior: boolean;
    public CuartoMedioExterior: boolean;
    public CurseEnsenhanzaModalidad: boolean;
    public RegionEstudio: Lookup;
    public EstablecimientoEducacionl: Lookup;
    public PrimeroMedio2x1: boolean;
    public SegundoMedio2x1: boolean;
    public TerceroMedio2x1: boolean;
    public CuartoMedio2x1: boolean;
    public AnhoEgresoEM: OptionSet;
    public CertificadoCulminacionEM: boolean;
    public IdContacto?: string;
    public IdProceso?: string;
    public CursoEM2x1: boolean;
    public BloqueoFinanciero: boolean;
    public SerialRut: string;

    public NotaPrimeroMedio: any;
    public NotaSegundoMedio: any;
    public NotaTerceroMedio: any;
    public NotaCuartoMedio: any;

    public CuarsandoCuartoMedio: boolean;

    constructor(data: any) {
        //Texto
        this.IdContacto = data.IdContacto;
        this.IdProceso = data.IdProceso;
        this.Rut = data.Rut;
        this.Nombre = data.Nombre;
        this.Nombre2 = data.Nombre2;
        this.ApellidoP = data.ApellidoP;
        this.ApellidoM = data.ApellidoM;
        this.FechaNacimiento = data.FechaNacimiento;
        this.CorreoElectronico = data.CorreoElectronico;
        this.Telefono = data.Telefono;
        this.Celular = data.Celular;
        this.Calle = data.Calle;
        this.CalleNro = data.CalleNro;
        this.CalleDpto = data.CalleDpto;
        this.Banco = data.Banco;
        this.TipoDeCuenta = data.TipoDeCuenta;
        this.NroDeCuenta = data.NroDeCuenta;
        this.SerialRut = data.SerialRut;

        //OptionSet
        this.TipoDocumentos = new OptionSet(data.TipoDocumentos);
        this.Nacionalidad = new OptionSet(data.Nacionalidad);
        this.Genero = new OptionSet(data.Genero);
        this.EstadoCivil = new OptionSet(data.EstadoCivil);
        this.PresentaDiscapacidad = new OptionSet(data.PresentaDiscapacidad);
        this.Etnia = new OptionSet(data.Etnia);
        this.AnhoEgresoEM = new OptionSet(data.AnhoEgresoEM);
        
        //Lookups
        this.Region = new Lookup(data.Region,"","xmsbs_region");
        this.Comuna = new Lookup(data.Comuna,"","xmsbs_comuna");
        this.Ciudad = new Lookup(data.Ciudad,"","xmsbs_ciudad");
        this.Pais = new Lookup(data.Pais,"","xmsbs_pais");
        this.RegionEstudio = new Lookup(data.RegionEstudio,"","xmsbs_region");
        this.EstablecimientoEducacionl = new Lookup(data.EstablecimientoEducacionl,"","xmsbs_colegioseinstituciones");

        //Boolean
        this.DeseaRecibirAsesoria = data.DeseaRecibirAsesoria;
        this.EnsenhazaMediaEextranjero = data.EnsenhazaMediaEextranjero;
        this.PrimeroMedioExterior = data.PrimeroMedioExterior;
        this.SegundoMedioExterior = data.SegundoMedioExterior;
        this.TerceroMedioExterior = data.TerceroMedioExterior;
        this.CuartoMedioExterior = data.CuartoMedioExterior;
        this.CurseEnsenhanzaModalidad = data.CurseEnsenhanzaModalidad;
        this.PrimeroMedio2x1 = data.PrimeroMedio2x1;
        this.SegundoMedio2x1 = data.SegundoMedio2x1;
        this.TerceroMedio2x1 = data.TerceroMedio2x1;
        this.CuartoMedio2x1 = data.CuartoMedio2x1;
        this.CertificadoCulminacionEM = data.CertificadoCulminacionEM;
        this.CursoEM2x1 = data.CursoEM2x1;
        this.BloqueoFinanciero = data.BloqueoFinanciero;

        this.NotaPrimeroMedio = data.NotaPrimeroMedio;
        this.NotaSegundoMedio = data.NotaSegundoMedio;
        this.NotaTerceroMedio = data.NotaTerceroMedio;
        this.NotaCuartoMedio = data.NotaCuartoMedio;
        this.CuarsandoCuartoMedio = data.CuarsandoCuartoMedio;
        

    }
}